import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/FormControl/form-control';
import { css } from '@patternfly/react-styles';
import { ValidatedOptions } from '../../helpers/constants';
export var TextInputTypes;

(function (TextInputTypes) {
  TextInputTypes["text"] = "text";
  TextInputTypes["date"] = "date";
  TextInputTypes["datetimeLocal"] = "datetime-local";
  TextInputTypes["email"] = "email";
  TextInputTypes["month"] = "month";
  TextInputTypes["number"] = "number";
  TextInputTypes["password"] = "password";
  TextInputTypes["search"] = "search";
  TextInputTypes["tel"] = "tel";
  TextInputTypes["time"] = "time";
  TextInputTypes["url"] = "url";
})(TextInputTypes || (TextInputTypes = {}));

export var TextInputBase =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextInputBase, _React$Component);

  function TextInputBase(props) {
    var _this;

    _classCallCheck(this, TextInputBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInputBase).call(this, props));

    _this.handleChange = function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event.currentTarget.value, event);
      }
    };

    if (!props.id && !props['aria-label'] && !props['aria-labelledby']) {
      // eslint-disable-next-line no-console
      console.error('Text input:', 'Text input requires either an id or aria-label to be specified');
    }

    return _this;
  }

  _createClass(TextInputBase, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          innerRef = _a.innerRef,
          className = _a.className,
          type = _a.type,
          value = _a.value,
          onChange = _a.onChange,
          validated = _a.validated,
          isReadOnly = _a.isReadOnly,
          isRequired = _a.isRequired,
          isDisabled = _a.isDisabled,
          props = __rest(_a, ["innerRef", "className", "type", "value", "onChange", "validated", "isReadOnly", "isRequired", "isDisabled"]);

      return React.createElement("input", Object.assign({}, props, {
        className: css(styles.formControl, validated === ValidatedOptions.success && styles.modifiers.success, className),
        onChange: this.handleChange,
        type: type,
        value: value,
        "aria-invalid": validated === ValidatedOptions.error,
        required: isRequired,
        disabled: isDisabled,
        readOnly: isReadOnly,
        ref: innerRef
      }));
    }
  }]);

  return TextInputBase;
}(React.Component);
TextInputBase.defaultProps = {
  'aria-label': null,
  className: '',
  isRequired: false,
  validated: 'default',
  isDisabled: false,
  isReadOnly: false,
  type: TextInputTypes.text,
  onChange: function onChange() {
    return undefined;
  }
};
export var TextInput = React.forwardRef(function (props, ref) {
  return React.createElement(TextInputBase, Object.assign({}, props, {
    innerRef: ref
  }));
});